import { MainObject, SubAnswer } from '../store/reports/types'

export const removeQuestionPropertyFromObjects = (objs: MainObject[] | SubAnswer[]): MainObject[] | SubAnswer[] => {
  return objs.map(obj => {
    if (!obj.id) {
      return obj
    }
    const {
      answer: { question, ...restAnswer },
      subanswers,
    } = obj
    let newSubanswers = undefined
    if (subanswers) {
      newSubanswers = removeQuestionPropertyFromObjects(subanswers)
    }
    return {
      ...obj,
      answer: restAnswer,
      ...(newSubanswers ? { subanswers: newSubanswers as SubAnswer[] } : {}),
    }
  })
}

export const removeFilesPropertyFromObjects = (objs: MainObject[] | SubAnswer[]): MainObject[] | SubAnswer[] => {
  return objs.map(obj => {
    const {
      answer: { files, ...restAnswer },
      subanswers,
    } = obj
    const newSubanswers = removeFilesPropertyFromObjects(subanswers)
    return { ...obj, answer: restAnswer, subanswers: newSubanswers as SubAnswer[] }
  })
}
export default {
  removeQuestionPropertyFromObjects,
  removeFilesPropertyFromObjects,
}
